"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyStages = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var MyStages = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyStages, _super);
    function MyStages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的分期';
        _this.code = '101131';
        _this.desc = '我的分期';
        _this.requestParams = new cashLoanAuth_1.MyStagesRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyStages;
}(service_1.BaseService));
exports.MyStages = MyStages;
//# sourceMappingURL=myStages.js.map